import { ArrangeProps, arrange } from './arrange';

/**
 * Rows can be used to place items over wrapping rows when items should
 * flow after each other instead of being placed in a grid.
 * Flexbox is used to achieve this goal.
 *
 * Responsibilities:
 *
 * 1. Place items and allow them to flow over multiple rows
 * 2. Space between items
 * 3. Alignment of items
 */

export const rows = (props: Omit<ArrangeProps<'rows'>, 'layout'>) => {
	return arrange({ ...props, layout: 'rows' });
};
